import { Table, Button, Tabs, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCheck, FaTimes, FaEdit, FaTrash } from "react-icons/fa";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { 
  useGetUsersQuery, 
  useDeleteUserMutation, 
  useGetDeliveryPartnersQuery,
  useApproveDeliveryPartnerMutation
} from "../../slices/usersApiSlice";
import { useState } from "react";

const UserListScreen = () => {
  const [activeTab, setActiveTab] = useState("pending");

  const { data: users, isLoading: isLoadingUsers, error: errorUsers, refetch: refetchUsers } = useGetUsersQuery();
  const { data: pendingPartners, isLoading: isLoadingPending, error: errorPending, refetch: refetchPending } = useGetDeliveryPartnersQuery("pending");
  const { data: approvedPartners, isLoading: isLoadingApproved, error: errorApproved, refetch: refetchApproved } = useGetDeliveryPartnersQuery("approved");
  const [approveDeliveryPartner, { isLoading: isLoadingApproval }] = useApproveDeliveryPartnerMutation();
  const [deleteUser, { isLoading: isLoadingDeleteUser }] = useDeleteUserMutation();

  const handleApproval = async (id, approval) => {
    try {
      await approveDeliveryPartner({ id, approval }).unwrap();
      toast.success(approval ? "Partner approved" : "Partner rejected");
      refetchPending();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const deleteUserHandler = async (id, refetchFn) => {
    if (window.confirm("Confirm user deletion")) {
      try {
        await deleteUser(id);
        refetchFn();
        toast.success("User deleted");
      } catch (error) {
        toast.error(error?.data?.message || error.error);
      }
    }
  };

  const renderTable = (data, isLoading, error, refetchFn, showApproval = false) => {
    if (isLoading) return <Loader />;
    if (error) return <Message variant="danger">{error}</Message>;
    if (!data || data.length === 0) return <Message>No records found</Message>;

    return (
      <Table striped hover responsive className="table-sm">
        <thead>
          <tr>
            <th>ID</th>
            <th>NAME</th>
            <th>EMAIL</th>
            <th>PHONE</th>
            {showApproval && <th>APPROVAL</th>}
            <th>EDIT</th>
            <th>DELETE</th>
          </tr>
        </thead>
        <tbody>
          {data.map((user) => (
            <tr key={user._id}>
              <td>{user._id}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.phone}</td>
              {showApproval && (
                <td>
                  <Button
                    variant="success"
                    className="btn-sm mx-1"
                    onClick={() => handleApproval(user._id, true)}
                  >
                    <FaCheck style={{ color: "white" }} />
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-sm"
                    onClick={() => handleApproval(user._id, false)}
                  >
                    <FaTimes style={{ color: "white" }} />
                  </Button>
                </td>
              )}
              <td>
                <Link to={`/admin/user/${user._id}/edit`}>
                  <Button variant="light" className="btn-sm mx-2">
                    <FaEdit />
                  </Button>
                </Link>
              </td>
              <td>
                <Button
                  variant="danger"
                  className="btn-sm"
                  onClick={() => deleteUserHandler(user._id, refetchFn)}
                >
                  <FaTrash style={{ color: "white" }} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <>
      <h2>Users</h2>
      {isLoadingDeleteUser && <Loader />}
      {isLoadingApproval && <Loader />}      
      
      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
        <Tab eventKey="pending" title="Delivery Partners (Pending)">
          {renderTable(pendingPartners, isLoadingPending, errorPending, refetchPending, true)}
        </Tab>

        <Tab eventKey="approved" title="Delivery Partners">
          {renderTable(approvedPartners, isLoadingApproved, errorApproved, refetchApproved, false)}
        </Tab>

        <Tab eventKey="users" title="Users">
          {renderTable(users, isLoadingUsers, errorUsers, refetchUsers)}
        </Tab>
      </Tabs>
    </>
  );
};

export default UserListScreen;